module.exports = __webpack_public_path__ + "static/legos-100033e7245e3f2ee417b48dea3e282f.png";